import {biLogger} from './bi-logger';

export class PrerenderReporter {
  private stateName: string;
  private eventName: string;
  private isActive: boolean = false;
  private logger;

  constructor() {
    this.isActive = typeof window !== 'undefined';
    if (!this.isActive) {
      return;
    }

    this.stateName = 'visibilityState';
    this.eventName = 'visibilitychange';
    if (typeof(document['msHidden']) !== 'undefined') {
      this.stateName = 'msVisibilityState';
      this.eventName = 'msvisibilitychange';
    } else if (typeof(document['webkitHidden']) !== 'undefined') {
      this.stateName = 'webkitVisibilityState';
      this.eventName = 'webkitvisibilitychange';
    }
    this.logger = biLogger.getLogger('pblc');
    this.visibilityStateChangeHandler = this.visibilityStateChangeHandler.bind(this);
    this.handleInteraction = this.handleInteraction.bind(this);
  }

  public start() {
    if (!this.isActive) {
      return;
    }
    this.reportPrerender();
    this.interactionElements.forEach(el => {
      this.interactionEvents.forEach(evType => {
        el.addEventListener(evType, this.handleInteraction);
      });
    });
  }

  public stop() {
    if (!this.isActive) {
      return;
    }
    document.removeEventListener(this.eventName, this.visibilityStateChangeHandler);
    this.interactionElements.forEach(el => {
      this.interactionEvents.forEach(evType => {
        el.removeEventListener(evType, this.handleInteraction);
      });
    });
  }

  private visibilityStateChangeHandler(e) {
    this.logger.preRenderedWixPageIsWasShownToUser({});
  }

  private reportPrerender() {
    const visibilityState = document[this.stateName];
    if (!visibilityState || visibilityState !== 'prerender') {
      return;
    }
    const biPromise =  this.logger.wixPageIsBeingPreRendered({});
    document.addEventListener(this.eventName, this.visibilityStateChangeHandler, {
      once: true,
    });

    return biPromise;
  }

  private reportedInteraction = false;
  private scrollEventCounter = 0;
  private interactionEvents: string[] = [
    // generic
    'click scroll resize',

    // touch
    'touchmove touchstart',

    // mouse
    'mousemove mousedown mouseup DOMMouseScroll mousewheel',

    // keyboard
    'keydown keyup keypress',

    // closing
    'beforeunload unload',

    // focusing in and our
    'focusin focusout focus blue pagehide'
  ].join(' ').split(' ');

  private handleInteraction (e) {
    if (this.reportedInteraction) {
        return;
    }

    // disregard first scroll event
    if (e.type === 'scroll' && ++this.scrollEventCounter <= 5) {
        return;
    }

    this.reportedInteraction = true;
    this.logger.prerenderingClassificationStage2HomePageInteraction({});
  }

  private interactionElements: EventTarget[] = typeof window === 'undefined' ? [] : [document, window, document.body, document.querySelector('main')].filter(el => el);
}
